import React from 'react';
import { Input } from 'reactstrap';
import NumberFormat from 'react-number-format';
import { FormattedMessage } from 'react-intl';
import { USER_ACCOUNT_BUSINESS } from '../../../constants/userDefs';

const USER_ID_COLUMN = {
  headerClassName: 'react-table-headers',
  className: 'react-table-cells',
  minWidth: 130,
  Header: <FormattedMessage id="adminEmployeesListPage.columns.id" />,
  accessor: 'id',
  Filter: ({ filter, onChange }) => (
    <Input
      className="w-100"
      tag={NumberFormat}
      allowNegative={false}
      decimalScale={0}
      value={filter ? filter.value : ''}
      onValueChange={values => onChange(values.floatValue)}
    />
  ),
};

const USER_EMAIL_COLUMN = {
  headerClassName: 'react-table-headers',
  className: 'react-table-cells',
  minWidth: 240,
  Header: <FormattedMessage id="adminUsersListPage.columns.email" />,
  accessor: 'email',
};

const USER_PHONE_NUMBER_COLUMN = {
  headerClassName: 'react-table-headers',
  className: 'react-table-cells',
  minWidth: 165,
  Header: <FormattedMessage id="adminUsersListPage.columns.phoneNumber" />,
  accessor: 'phoneNumber',
};

const USER_OIB_COLUMN = {
  headerClassName: 'react-table-headers',
  className: 'react-table-cells',
  minWidth: 130,
  Header: <FormattedMessage id="adminUsersListPage.columns.OIB" />,
  accessor: 'oib',
};

const USER_FIRST_NAME_COLUMN = {
  headerClassName: 'react-table-headers',
  className: 'react-table-cells',
  minWidth: 150,
  Header: <FormattedMessage id="adminUsersListPage.columns.firstName" />,
  accessor: 'firstName',
  Cell: rowInfo =>
    rowInfo.original.sector === USER_ACCOUNT_BUSINESS ? rowInfo.original.businessFirstName : rowInfo.original.firstName,
};

const USER_LAST_NAME_COLUMN = {
  headerClassName: 'react-table-headers',
  className: 'react-table-cells',
  minWidth: 150,
  Header: <FormattedMessage id="adminUsersListPage.columns.lastName" />,
  accessor: 'lastName',
  Cell: rowInfo =>
    rowInfo.original.sector === USER_ACCOUNT_BUSINESS ? rowInfo.original.businessLastName : rowInfo.original.lastName,
};

export const columns = [
  USER_ID_COLUMN,
  USER_FIRST_NAME_COLUMN,
  USER_LAST_NAME_COLUMN,
  USER_EMAIL_COLUMN,
  USER_OIB_COLUMN,
  USER_PHONE_NUMBER_COLUMN,
];
